export const CREATE_USER_PURCHASE = 'CREATE_USER_PURCHASE';
export const CREATE_USER_PURCHASE_ASYNC = 'CREATE_USER_PURCHASE_ASYNC';
export const CLEAR_DATA_PURCHASE = 'CLEAR_DATA_PURCHASE';
export const GET_USER_PURCHASES = 'GET_USER_PURCHASES';
export const GET_USER_PURCHASES_ASYNC = 'GET_USER_PURCHASES_ASYNC';
